import OnboardingFooter from '../../components/OnboardingFooter';
import ForgotPassword from '../../views/ForgotPassword';

export default function ForgotPasswordPage() {
  return (
    <main className="relative z-10 flex flex-1 flex-col items-center justify-between gap-10 pb-5">
      <div className="flex w-full flex-1 flex-col items-center pt-14 md:pt-16 lg:pt-20">
        <div className="mb-7 flex flex-col items-center gap-2.5 px-10 text-center sm:px-0 md:mb-10 lg:mb-11">
          <img
            src="/assets/images/logo.png"
            alt="logo"
            className="h-85 w-69 md:h-100 md:w-20 lg:h-150 lg:w-121"
          />
          <h2 className="text-brand-byzantine font-bold">Forgot Password?</h2>
          <h5 className="font-inter-variable medium text-brand-byzantine -tracking-sign-up-header-title mx-auto max-w-545 text-base leading-5 italic md:text-xl md:leading-6 lg:max-w-685 lg:text-2xl lg:leading-7">
            Enter the email associated with your account and we’ll send you an
            email with a link to reset your password.
          </h5>
        </div>
        <div className="w-full px-25">
          <ForgotPassword />
        </div>
      </div>
      <OnboardingFooter />
    </main>
  );
}
